import { render, staticRenderFns } from "./editGoods.vue?vue&type=template&id=1244dea4&scoped=true&"
import script from "./editGoods.vue?vue&type=script&lang=js&"
export * from "./editGoods.vue?vue&type=script&lang=js&"
import style0 from "./editGoods.vue?vue&type=style&index=0&id=1244dea4&lang=scss&scoped=true&"
import style1 from "./editGoods.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1244dea4",
  null
  
)

component.options.__file = "editGoods.vue"
export default component.exports